<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="purchasevoucherLog"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {	
				if (e) {
					this.$api.log.list({
						dataid:e.id,
						formname:'bi_purchase',
					}).then((res) => {
						//console.log(res)
						this.$refs.purchasevoucherLog.reloadData(res)
					})
				} else {
					this.$refs.purchasevoucherLog.reloadData([])
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.gridOptions = this.getOption()	
		},
		methods: {
			getOption() {
				return {
					id: 'purchasevoucherLog',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: [],
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: '220',
					pagerConfig: {
						enabled: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [
				{
					field: 'staffid',
					title: '操作人',
					formatter:({row})=>{
						return window.systemMethods.getstaff(row.staffid)
					}
				},
				// {
				// 	field: 'postjob',
				// 	title: '岗位',
				// 	formatter:({row})=>{
				// 		return window.systemMethods.getpostjob(row.postjob)
				// 	}
				// }, 
				{
					field: 'action',
					title: '操作',
					formatter:({row})=>{
						let map = {
							uploadvoucher:'上传凭证',
							clearvoucher:'清空凭证',
							updatevoucher:'更新凭证',
							synchronousvoucher:'同步凭证',
							paysuccess:'付款成功',
							payfail:'付款失败',
							apply:'付款申请',
							signature:'签章',
							backsignature:'反签章',
							audit:'核对',
							clearaudit:'撤销核对',
							reject:'驳回',
						}
						return map[row.action]
					}
				},  {
					field: 'create_time',
					title: '操作时间',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.create_time,false)
					}
				}]
			}
		},
		components: {
			
		}
	}
</script>